(function () {
  'use strict';

  var rail = document.querySelector('[data-csa-section-rail]');
  var headerSection = null;
  var siteHeader = null;
  var announcement = null;
  var headerObserver = null;
  var observedHeaderSection = null;
  var railLinks = [];
  var sections = [];
  var toneSections = [];
  var activeId = '';
  var ticking = false;

  function refreshHeaderElements() {
    var nextHeaderSection = document.getElementById('shopify-section-header');
    headerSection = nextHeaderSection;
    siteHeader = headerSection && headerSection.querySelector('.site-header');
    announcement = headerSection && headerSection.querySelector('.announcement-bar');

    if (headerObserver && observedHeaderSection !== headerSection) {
      if (observedHeaderSection) headerObserver.unobserve(observedHeaderSection);
      if (headerSection) headerObserver.observe(headerSection);
      observedHeaderSection = headerSection;
    }
  }

  function getStickyRailHeight() {
    if (!rail || window.getComputedStyle(rail).position !== 'sticky') return 0;
    return rail.getBoundingClientRect().height;
  }

  function updateHeaderMetrics() {
    refreshHeaderElements();
    var announcementHeight = announcement ? announcement.getBoundingClientRect().height : 0;
    var headerHeight = siteHeader ? siteHeader.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--csa-announcement-height', announcementHeight + 'px');
    document.documentElement.style.setProperty('--csa-sticky-header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--csa-sticky-section-nav-height', getStickyRailHeight() + 'px');
    updateActiveSection();
  }

  function buildRail() {
    if (!rail) return;

    sections = Array.prototype.slice.call(document.querySelectorAll('.csa-section[id][data-csa-nav-label]')).filter(function (section) {
      return section.getAttribute('data-csa-nav-label').trim() !== '';
    });
    toneSections = Array.prototype.slice.call(document.querySelectorAll('.csa-section[id][data-csa-nav-tone]'));

    var fragment = document.createDocumentFragment();
    sections.forEach(function (section) {
      var link = document.createElement('a');
      var mark = document.createElement('span');
      var label = document.createElement('span');

      link.className = 'csa-section-rail__link';
      link.href = '#' + section.id;
      link.setAttribute('data-csa-rail-link', '');
      mark.className = 'csa-section-rail__mark';
      mark.setAttribute('aria-hidden', 'true');
      label.textContent = section.getAttribute('data-csa-nav-label').trim();
      link.appendChild(mark);
      link.appendChild(label);
      link.addEventListener('click', jumpToSection);
      fragment.appendChild(link);
    });

    rail.textContent = '';
    rail.appendChild(fragment);
    railLinks = Array.prototype.slice.call(rail.querySelectorAll('[data-csa-rail-link]'));
    activeId = '';
  }

  function setActive(id) {
    if (!id || id === activeId) return;
    activeId = id;
    railLinks.forEach(function (link) {
      var isActive = link.getAttribute('href') === '#' + id;
      link.classList.toggle('is-active', isActive);
      if (isActive) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  }

  function updateActiveSection() {
    refreshHeaderElements();
    var headerHeight = siteHeader ? siteHeader.getBoundingClientRect().height : 0;
    var marker = headerHeight + getStickyRailHeight() + Math.min(window.innerHeight * 0.28, 240);
    var current = sections[0];

    sections.forEach(function (section) {
      if (section.getBoundingClientRect().top <= marker) current = section;
    });

    if (current) setActive(current.id);
    updateRailTone();
    if (headerSection) {
      var announcementHeight = announcement ? announcement.getBoundingClientRect().height : 0;
      headerSection.classList.toggle('is-stuck', window.scrollY > announcementHeight + 2);
    }
  }

  function updateRailTone() {
    if (!rail || window.getComputedStyle(rail).position !== 'fixed') {
      railLinks.forEach(function (link) {
        link.classList.remove('is-on-dark');
      });
      return;
    }

    railLinks.forEach(function (link) {
      var linkRect = link.getBoundingClientRect();
      var linkCenter = linkRect.top + (linkRect.height / 2);
      var sectionBehindLink = toneSections.find(function (section) {
        var sectionRect = section.getBoundingClientRect();
        return sectionRect.top <= linkCenter && sectionRect.bottom > linkCenter;
      });
      var tone = sectionBehindLink && sectionBehindLink.getAttribute('data-csa-nav-tone');
      link.classList.toggle('is-on-dark', tone === 'dark');
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      updateActiveSection();
      ticking = false;
    });
  }

  function jumpToSection(event) {
    refreshHeaderElements();
    var target = document.querySelector(this.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    var headerHeight = siteHeader ? siteHeader.getBoundingClientRect().height : 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - getStickyRailHeight() - 14;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: top, behavior: reducedMotion ? 'auto' : 'smooth' });
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + target.id);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateHeaderMetrics);
  window.addEventListener('load', function () {
    updateHeaderMetrics();
    if (window.location.hash) {
      var target = document.querySelector(window.location.hash);
      if (target) {
        window.setTimeout(function () {
          var headerHeight = siteHeader ? siteHeader.getBoundingClientRect().height : 0;
          window.scrollTo(0, target.getBoundingClientRect().top + window.pageYOffset - headerHeight - getStickyRailHeight() - 14);
        }, 60);
      }
    }
  });

  if (window.ResizeObserver) {
    headerObserver = new ResizeObserver(updateHeaderMetrics);
    refreshHeaderElements();
  }

  if (window.ResizeObserver && rail) {
    new ResizeObserver(updateHeaderMetrics).observe(rail);
  }

  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      window.requestAnimationFrame(function () {
        buildRail();
        updateHeaderMetrics();
      });
    });
  });

  buildRail();
  updateHeaderMetrics();
})();
